import React from "react";
import conf from "../../conf/conf";

export default function TermsOfService() {
  const email_id = conf.email_id;
  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6 mt-24">
      <h1 className="text-3xl font-bold">Terms of Service</h1>
      <p>Last updated: August 30, 2025</p>

      <p>
        By using <strong>JobIntelPro</strong>, you agree to the following terms
        and conditions. Please read them carefully.
      </p>

      <h2 className="text-xl font-semibold">1. Use of Service</h2>
      <ul className="list-disc list-inside space-y-1 text-left">
        <li>You must be at least 16 years old to use JobIntelPro.</li>
        <li>
          You are responsible for maintaining the confidentiality of your
          account.
        </li>
        <li>
          You agree not to misuse the platform (spam, fake postings, scraping).
        </li>
      </ul>

      <h2 className="text-xl font-semibold">2. Job Listings & Applications</h2>
      <ul className="list-disc list-inside space-y-1 text-left">
        <li>Employers are responsible for the accuracy of job postings.</li>
        <li>
          Job seekers are responsible for the accuracy of their applications.
        </li>
        <li>JobIntelPro does not guarantee employment or job offers.</li>
      </ul>

      <h2 className="text-xl font-semibold">3. Content Ownership</h2>
      <p>
        You retain ownership of the content you post. By posting jobs or
        resumes, you grant JobIntelPro a non-exclusive license to display and
        distribute that content on the platform.
      </p>

      <h2 className="text-xl font-semibold">4. Limitation of Liability</h2>
      <p>
        JobIntelPro is not liable for any direct, indirect, or incidental
        damages resulting from the use of our platform. We act as a facilitator
        between job seekers and employers but do not control the outcomes of
        employment.
      </p>

      <h2 className="text-xl font-semibold">5. Termination</h2>
      <p>
        We reserve the right to suspend or terminate accounts that violate these
        Terms of Service.
      </p>

      <h2 className="text-xl font-semibold">6. Governing Law</h2>
      <p>
        These Terms are governed by the laws of India. Any disputes shall be
        resolved under the jurisdiction of the courts in [Your City, India].
      </p>

      <h2 className="text-xl font-semibold">7. Contact</h2>
      <p>
        For questions regarding these Terms, contact us at
        <strong>
          {" "}
          <a
            href={`mailto:${email_id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:underline"
          >
            JobIntelPro
          </a>
        </strong>
        .
      </p>
    </div>
  );
}
